import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";

export function checkout(sale) {
   const request = axios.post(urls.ORDER_CHECKOUT_URL, sale);
    return { type: ActionTypes.ORDER_CHECKOUT, payload: request };
}


export function buildCheckoutSale(sale) {
    sale.readOnlyCheckout = true;
    const request = axios.post(urls.ORDER_CHECKOUT_URL, sale);
    return { type: ActionTypes.BUILD_CHECKOUT_SALE, payload: request };
}


export function storeCheckoutSale(sale) {
    return { type: ActionTypes.STORE_LOCAL_SALE, payload: sale };
}

export function clearCheckoutSale() {
    return { type: ActionTypes.CLEAR_LOCAL_SALE, payload: null };
}

export function authorizePayment(externalRedirectPaymentOptions) {
    const request = axios.post(urls.AUTHORIZE_PAYMENTS_URL, externalRedirectPaymentOptions);
    return { type: ActionTypes.AUTHORIZE_PAYMENT, payload: request };
}


export function cancelExternalRedirect() {
    return { type: ActionTypes.CANCEL_EXTERNAL_REDIRECT, payload: null };
}

export function createStripeCardToken(stripe, element) {
    const request = stripe.createToken(element)
    return { type: ActionTypes.CREATE_STRIPE_CARD_TOKEN, payload: request  }
}
